













































import { Component, Vue, Prop } from 'vue-property-decorator';
import get from 'lodash/get';
import Lot from '../../models/Lot';
import { formatLotType } from '@/data/lot';

const lotKeys = {
    floor: 'Étage',
    exposure: 'Exposition',
    surface_carrez: 'Surface > 1.8 m²',
    surface_no_carrez: 'Surface < 1.8 m²',
    surface_terrace: 'Surface Balcon',
    surface_copro_garden: 'Surface Jardin',
    surface_land: 'Surface Terrain',
    rent_limit_pk_included: 'Plafond loyer PK',
    rent_limit_pk_alone: 'Plafond loyer PK seul',
    rent_limit_lgt_alone: 'Plafond LGT seul',
    amount_property: 'Montant foncier hors travaux',
    amount_work: 'Montant travaux',
    amount_work_no_defisc: 'Montant travaux hors defisc',
    price_parking: 'Prix parking',
    selling_fee: 'Honoraires',
    location_amount_property: 'LMNP immobilier HT',
    location_amount_furniture: 'LMNP mobilier HT',
    location_amount_vat_back: 'LMNP Tva Récup',
    rent_for_resseling: 'Montant loyer',
    profitability: 'Rentabilité',
};

const lotValues = {
    surface_carrez: surface,
    surface_no_carrez: surface,
    surface_terrace: surface,
    surface_copro_garden: surface,
    surface_land: surface,
    rent_limit_pk_included: euro,
    rent_limit_pk_alone: euro,
    rent_limit_lgt_alone: euro,
    amount_property: euro,
    amount_work: euro,
    amount_work_no_defisc: euro,
    price_parking: euro,
    selling_fee: euro,
    location_amount_property: euro,
    location_amount_furniture: euro,
    location_amount_vat_back: euro,
    rent_for_resseling: euro,
};

const keys = [
    [
        'floor',
        'exposure',
        'surface_carrez',
        'surface_no_carrez',
        'surface_copro_garden',
        'surface_terrace',
        'surface_land',
        'rent_limit_pk_included',
        'rent_limit_pk_alone',
        'rent_limit_lgt_alone',
    ],
    [
        'amount_property',
        'amount_work',
        'amount_work_no_defisc',
        'selling_fee',
        'location_amount_property',
        'location_amount_furniture',
        'location_amount_vat_back',
        'rent_for_resseling',
        'price_parking',
        'profitability',
    ],
];

function formatLotKey(key: string) {
    return get(lotKeys, key, key);
}

function formatLotValue(value: string, key: string) {
    if (!value) {
        return '';
    }

    const fn = get(lotValues, key, (value: string) => value);

    return fn(value);
}

function euro(value: number) {
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
    }).format(value);
}

function surface(value: number | string) {
    if (value === 0 || value === '0') {
        return value;
    }
    return `${value} m²`;
}

@Component({
    filters: {
        euro,
        formatLotKey,
        formatLotValue,
        formatLotType,
    },
})
export default class LotTable extends Vue {
    @Prop() lot!: Lot | undefined;
    keys = keys;

    get parkings() {
        if (!this.lot) {
            return;
        }

        const parkings = [
            {
                cat: this.lot.cat_parking1,
                name: this.lot.name_parking1,
            },
            {
                cat: this.lot.cat_parking2,
                name: this.lot.name_parking2,
            },
            {
                cat: this.lot.cat_parking3,
                name: this.lot.name_parking3,
            },
        ];

        return parkings.filter(parking => parking.cat && parking.name);
    }
}
